import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const GiftModal = ({
    openGiftModal,
    setOpenGiftModal,
    selectedOption,
    handleSelect
}) => {
    const navigate = useNavigate();
    return (
        <Transition appear show={openGiftModal} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-50"
                onClose={() => setOpenGiftModal(false)}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-xl bg-white text-left align-middle shadow-xl transition-all">
                                <div className="scrollbar-thumb-[#1a3517] scrollbar-track-[#265426] h-full max-h-[525px] overflow-y-scroll p-2 scrollbar-thin">
                                    <div
                                        onClick={() =>
                                            setOpenGiftModal(false)
                                        }
                                        className="fixed right-4 top-3 w-fit cursor-pointer rounded-full p-1.5 text-gray-700 hover:bg-gray-200 active:bg-gray-100"
                                    >
                                        <IoClose
                                            onClick={() => {
                                                setOpenGiftModal(false)
                                            }}
                                            className="h-5 w-5"
                                        />
                                    </div>
                                    <div className="mb-6 px-2 sm:px-6">
                                        <h2 className="mt-6 text-xl font-bold text-gray-700">
                                            Add New Item
                                        </h2>
                                        <div>
                                            <div
                                                className={`mt-6 cursor-pointer p-4 rounded-xl border ${selectedOption === "plan" ? "border-blue-500 bg-blue-50" : "border-gray-200"
                                                    }`}
                                                onClick={() => handleSelect("plan")}
                                            >
                                                <h3 className="text-base font-bold text-gray-600">Add Food Basket</h3>
                                                <p className="text-sm text-gray-600">Shop and Gift our Curated Plans</p>
                                            </div>

                                            <div
                                                className={`mt-4 cursor-pointer p-4 rounded-xl border ${selectedOption === "basket" ? "border-blue-500 bg-blue-50" : "border-gray-200"
                                                    }`}
                                                onClick={() => handleSelect("basket")}
                                            >
                                                <h3 className="text-base font-bold text-gray-600">Add Custom Basket</h3>
                                                <p className="text-sm text-gray-600">Shop and Gift a Customised basket</p>
                                            </div>
                                            <div
                                                className={`mt-4 cursor-pointer p-4 rounded-xl border ${selectedOption === "grochill" ? "border-blue-500 bg-blue-50" : "border-gray-200"
                                                    }`}
                                                onClick={() => handleSelect("grochill")}
                                            >
                                                <h3 className="text-base font-bold text-gray-600">Add GroChill Basket</h3>
                                                <p className="text-sm text-gray-600">Shop and Gift a Customised GroChill</p>
                                            </div>
                                        </div>
                                        <div className="mt-8 flex items-center justify-between">
                                            <button
                                                className="w-fit transform cursor-pointer rounded-md border-[1px] border-gray-300 bg-white px-10 py-3 text-sm font-semibold text-gray-600 transition-all duration-200 focus:outline-none"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={() => {
                                                    if (selectedOption === "plan") {
                                                        return navigate(`/home/plans/1`);
                                                    } else if (selectedOption === "basket") {
                                                        return navigate("/basket/create-basket")
                                                    } else if (selectedOption === "grochill") {
                                                        return navigate("/grochill/create-basket")
                                                    } else {
                                                        return;
                                                    }
                                                }}
                                                className={`w-fit transform rounded-md px-10 py-3 text-sm font-semibold text-white transition-all duration-200 focus:outline-none @sm:max-w-[180px] cursor-pointer bg-[#558223] hover:bg-olivine-500/80 active:bg-olivine-600`}
                                            >
                                                Proceed
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default GiftModal;